import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3f3ea845&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=3f3ea845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3ea845",
  null
  
)

export default component.exports